import React, { useState, useEffect } from 'react';
import { DocumentTree } from '../../components/Documents/DocumentTree';
import { documentService } from '../../services/documentService';
import { DocumentNode } from '../../types/documents';

const DocumentTreeTest: React.FC = () => {
  const [treeData, setTreeData] = useState<DocumentNode | null>(null);
  const [selectedNode, setSelectedNode] = useState<DocumentNode | null>(null);
  const [logs, setLogs] = useState<string[]>([]);

  const addLog = (message: string) => {
    setLogs(prev => [...prev, `${new Date().toLocaleTimeString()}: ${message}`]);
  };

  useEffect(() => {
    addLog('Carregando árvore inicial...');
    documentService.getDocumentWithChildren('/')
      .then(data => {
        setTreeData(data);
        addLog('Árvore inicial carregada com sucesso');
      })
      .catch(err => {
        addLog(`Erro ao carregar árvore: ${err.message}`);
      });
  }, []);

  const onExpandNode = async (node: DocumentNode) => {
    addLog(`Expandindo nó: ${node.title} (${node.path})`);
    try {
      let data: DocumentNode;
      
      // Usar sempre getDocumentWithChildren para consistência
      addLog('Chamando API getDocumentWithChildren');
      data = await documentService.getDocumentWithChildren(node.path);
      
      addLog(`Resposta da API: ${data.children?.length || 0} filhos encontrados`);
      
      setTreeData(prev => {
        if (!prev) return prev;
        const updateNode = (n: DocumentNode): DocumentNode => {
          if (n.id === node.id) {
            addLog(`Atualizando nó ${n.title} com ${data.children?.length || 0} filhos`);
            return { 
              ...n, 
              children: data.children || [],
              countChild: data.countChild || 0
            };
          }
          if (n.children) {
            return { ...n, children: n.children.map(updateNode) };
          }
          return n;
        };
        return updateNode(prev);
      });
    } catch (error) {
      addLog(`Erro em onExpandNode: ${error}`);
    }
  };

  const handleNodeSelect = (node: DocumentNode) => {
    addLog(`Nó selecionado: ${node.title} (${node.nodeType})`);
    setSelectedNode(node);
  };

  const handleDeleteNode = (node: DocumentNode) => {
    addLog(`Solicitando exclusão do nó: ${node.title}`);
  };

  return (
    <div className="flex h-screen">
      <div className="w-1/2 p-4">
        <h2 className="text-lg font-bold mb-4">Árvore de Documentos</h2>
        <DocumentTree 
          treeData={treeData}
          onNodeSelect={handleNodeSelect}
          selectedNode={selectedNode}
          onExpandNode={onExpandNode}
          onDeleteNode={handleDeleteNode}
          onNodeRenamed={() => {
            documentService.getDocumentWithChildren('/').then(setTreeData).catch(() => {});
          }}
        />
      </div>
      <div className="w-1/2 p-4 bg-gray-100">
        <h2 className="text-lg font-bold mb-4">Logs de Teste</h2>
        <div className="bg-white p-4 rounded border h-full overflow-y-auto">
          {logs.map((log, index) => (
            <div key={index} className="text-sm font-mono mb-1">
              {log}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DocumentTreeTest; 